import { render, staticRenderFns } from "./DepartmentItem.vue?vue&type=template&id=5f0b97c3&scoped=true"
import script from "./DepartmentItem.ts?vue&type=script&lang=ts&external"
export * from "./DepartmentItem.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0b97c3",
  null
  
)

export default component.exports